import './index.scss'

const FormLabel = ({ htmlFor, required, className, children }) => {
    const classes = ['form-label']
    if (required) classes.push('form-label--required')
    if (className) classes.push(className)

    return (
        <label htmlFor={htmlFor} className={classes.join(' ')}>
            {children}
            {required && (
                <>
                    <span className="form-label-required-dot" aria-hidden="true" />
                    <span className="form-label-required-tooltip" role="tooltip">Campo obligatorio</span>
                </>
            )}
        </label>
    )
}

export default FormLabel
